import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import image1 from '../assets/home/image1.jpeg';
import './Main.css';

const Main = () => {
    const navigate = useNavigate();
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
    const handleResize = () => {
        setSize({
        width: window.innerWidth,
        height: window.innerHeight,
        });
    };

    window.addEventListener('resize', handleResize);

    // 컴포넌트 언마운트 시 이벤트 제거
    return () => window.removeEventListener('resize', handleResize);
    }, []);

    const goToGallery = () => {
        navigate('/pages/gallery')
    }

    const goToAbout = () => {
        navigate('/pages/about')
    }

    const goToContact = () => {
        navigate('/pages/contact')
    }

    return(
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 8px",}}>
            <div style={{display: "flex", justifyContent: "center", gap: 32, marginBottom: 32}}>
                <div onClick={goToGallery} className="nav-item">GALLERY</div>
                <div onClick={goToAbout} className="nav-item">ABOUT</div>
                <div onClick={goToContact} className="nav-item">CONTACT</div>
            </div>
            <img src={image1} style={{width: size.width <= 1280 ? size.width - 16 : 1280, height: "auto"}} />
        </div>
    )
}

export default Main;